import createIcon from '../../createIcon';

/**
 * @component @name ArrowBackIos
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuODM1IDMuODY5NjFMMTYuMDY1IDIuMDk5NjFMNi4xNjUwNCAxMS45OTk2TDE2LjA2NSAyMS44OTk2TDE3LjgzNSAyMC4xMjk2TDkuNzA1MDQgMTEuOTk5NkwxNy44MzUgMy44Njk2MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowBackIos = createIcon('ArrowBackIos', [
  [
    'path',
    {
      d: 'M17.835 3.86961L16.065 2.09961L6.16504 11.9996L16.065 21.8996L17.835 20.1296L9.70504 11.9996L17.835 3.86961Z',
      key: '18xnsz',
    },
  ],
]);

export default ArrowBackIos;
